import type { ReactNode } from 'react';
import React from 'react';
import styled from 'styled-components';

import { DSTokenMap, MQ } from '@rover/kibble/styles';

import type { Props as DialogModalButtonsProps } from './DialogModalButtons';
import DialogModalButtons from './DialogModalButtons';

export const Column = styled.div`
  display: flex;
  flex-basis: auto;
  flex-direction: column;
  height: 100%;

  ${MQ.NOT_XS.toString()} {
    height: auto;
  }
`;
export const Body = styled.div`
  flex: 1;
  flex-basis: auto;
  padding: 20px;

  ${MQ.NOT_XS.toString()} {
    padding: 0 0 20px;
  }
`;
export const Header = styled.div<{ hasCloseButton?: boolean }>`
  min-height: 46px;
  margin: 0;
  border-bottom: 1px solid ${DSTokenMap.BORDER_COLOR_PRIMARY.toString()};
  font-family: ${DSTokenMap.HEADING_400_FONT_FAMILY};
  text-align: center;
  font-size: 18px;
  font-weight: 400;
  padding: ${({ hasCloseButton }) =>
    hasCloseButton ? `${DSTokenMap.SPACE_2X} ${DSTokenMap.SPACE_12X}` : DSTokenMap.SPACE_2X};
  ${MQ.NOT_XS.toString()} {
    height: auto;
    line-height: 1.6;
    padding-bottom: 20px;
    padding-left: 0px;
    border-bottom: 0;
    text-align: left;
    font-size: 26px;
  }
`;
export type Props = DialogModalButtonsProps & {
  children: ReactNode;
  headerId?: string;
  headerText: ReactNode | string;
  shouldNotClose?: boolean;
  className?: string;
  hasCloseButton?: boolean;
};

const DialogModalContent = (props: Props): JSX.Element => {
  const {
    cancelButtonText,
    children,
    headerId,
    headerText,
    onClickCancel,
    onClickSubmit,
    submitButtonText,
    submitButtonDisabled,
    hasCloseButton,
  } = props;
  const buttonProps = {
    cancelButtonText,
    submitButtonText,
    onClickCancel,
    onClickSubmit,
    submitButtonDisabled,
  };

  return (
    <Column>
      {headerText && (
        <Header id={headerId} data-qa-id="modal-element-title" hasCloseButton={hasCloseButton}>
          {headerText}
        </Header>
      )}

      <Body data-qa-id="modal-body">{children}</Body>
      <DialogModalButtons {...buttonProps} />
    </Column>
  );
};

export default DialogModalContent;
